import { APIConfig, BaseAPIConfig, buildConfig, ConfigEnvironment, ConfigMap } from "@eres/api";

interface IEjariConfig extends APIConfig {
	paymentPage(): string;

	shortUrl(): string;
}

export class EjariConfig extends BaseAPIConfig implements IEjariConfig {
	protected mPaymentPage: string;
	protected mShortUrl: string;

	constructor( protocol: string, server: string, app: string, api: string, paymentPage: string, shortUrl: string ) {
		super( protocol, server, app, api );
		this.mPaymentPage = paymentPage;
		this.mShortUrl = shortUrl;
	}

	paymentPage(): string {
		return this.mPaymentPage;
	}

	shortUrl(): string {
		return this.mShortUrl;
	}

	updateFromData( data: any ): boolean {
		const r = super.updateFromData( data );
		if ( data && typeof data === "object" ) {
			if ( data.paymentPage ) this.mPaymentPage = data.paymentPage;
			if ( data.shortUrl ) this.mShortUrl = data.shortUrl;
		}
		return r;
	}
}

interface RestConfig {
	ejariAPI: () => IEjariConfig;
	ejariRxApi: () => APIConfig;
	ejariPropertyWalletAPI: () => APIConfig;
}

const dev: RestConfig = {
	ejariAPI: () => new EjariConfig( "https", "devmobile.dubailand.gov.ae", "ejari.mobile", "", "Payment/Payment.aspx", "https://eres.ae/g/" ),
	ejariRxApi: () => new BaseAPIConfig( "https", "devmobile.dubailand.gov.ae", "Ejari.Server.WebAPI", "api/v1/RentalIndex" ),
	ejariPropertyWalletAPI: () => new BaseAPIConfig( "https", "devgate.dubailand.gov.ae", "ejarimobile/propertywallet", "" ),
};

const qa: RestConfig = {
	ejariAPI: () => new EjariConfig( "https", "stgapi2.dubailand.gov.ae", "ejarimobile", "", "Payment/Payment.aspx", "https://eres.ae/s/" ),
	ejariRxApi: () => new BaseAPIConfig( "https", "gateway.dubailand.gov.ae", "ejarirentalindex", "" ),
	ejariPropertyWalletAPI: () => new BaseAPIConfig( "https", "stgapi2.dubailand.gov.ae", "ejari-pw", "" ),
};

const prod: RestConfig = {
	ejariAPI: () => new EjariConfig( "https", "b2c.dubailand.gov.ae", "ejarimobile", "", "Payment/Payment.aspx", "https://eres.ae/p/" ),
	ejariRxApi: () => new BaseAPIConfig( "https", "gateway.dubailand.gov.ae", "ejarirentalindex", "" ),
	ejariPropertyWalletAPI: () => new BaseAPIConfig( "https", "b2c.dubailand.gov.ae", "ejari-pw", "" ),
};

const configs: ConfigMap<RestConfig> = {
	dev: dev,
	qa: qa,
	production: prod,
};

const cfg = buildConfig<RestConfig, ConfigEnvironment>( "dev", configs );
export default cfg;
